export type PaginationQuery = {
	page?: number;
	size?: number;
};

const createPaginationQuery = (query?: PaginationQuery) => {
	return `page=${query?.page ?? 0}&size=${query?.size ?? 20}`;
};

export const createPaginatedUrl = (url: string, query?: PaginationQuery) => {
	const hasQuery = url.includes('?');
	if (hasQuery) {
		return `${url}&${createPaginationQuery(query)}`;
	} else {
		return `${url}?${createPaginationQuery(query)}`;
	}
};

export interface PaginationModel<T = any> {
	data: T;
	page: PaginationQuery;
}

export const createPaginationModel = <T = any, K = any>(
	translate: (a: T[]) => K[],
	data?: T[],
	page?: PaginationQuery
): PaginationModel<K[]> => {
	return {
		data: data ? translate(data) : [],
		page: page ?? { size: 0, page: 0 }
	};
};
